import Notify from 'quasar/src/plugins/Notify.js';;
import { boot } from 'quasar/wrappers';
import 'moment/locale/it';
Notify.setDefaults({
    actions: [{ label: 'chiudi', color: 'white' }],
});
Notify.registerType('negative', {
    position: 'bottom-right',
    icon: 'mdi-alert-circle',
    color: 'negative',
});
Notify.registerType('warning', {
    icon: 'mdi-alert',
    color: 'amber',
});
export default boot(({ app }) => {
    for (const size of ['Xl', 'Lg', 'Md', 'Sm', 'Xs']) {
        app.component(`${size}Disposition`, defineAsyncComponent(() => import(`components/dispositions/${size}Disposition.vue`)));
        app.component(`${size}SalesDisposition`, defineAsyncComponent(() => import(`components/dispositions/${size}SalesDisposition.vue`)));
    }
});
